import { Request, Response, NextFunction, RequestHandler } from 'express';
import { v4 as uuidv4 } from 'uuid';
import { CorrelationIdOptions } from './types';

/**
 * Middleware to track correlation ID across requests
 *
 * @param options Correlation ID options
 * @returns Express middleware
 */
export function correlationIdMiddleware(options: CorrelationIdOptions = {}): RequestHandler {
  const headerName = options.header || 'X-Correlation-ID';
  const propertyName = options.propertyName || 'correlationId';
  const generateId = options.generateId !== false;

  return (req: Request, res: Response, next: NextFunction) => {
    // Get correlation ID from header or generate a new one
    let correlationId = req.headers[headerName.toLowerCase()] as string;

    if (!correlationId && generateId) {
      correlationId = uuidv4();
    }

    if (correlationId) {
      // Add correlation ID to request object
      (req as any)[propertyName] = correlationId;

      // Set correlation ID header in response
      res.setHeader(headerName, correlationId);
    }

    next();
  };
}
